import { HttpService } from '../https.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CorporateListService {

  constructor(private httpService: HttpService) {}

  getCorporateProfessionals(): Observable<any> {
    return this.httpService.sendRePostRequest('/professional/search/corporate', {}) as Observable<any>;
  }
}